module.exports = __webpack_public_path__ + "static/media/LindeDaxRegWeb.54376284.woff";